import React from 'react';
import moment from 'moment';
import {typography} from 'material-ui/styles';
import utils from '../../utility/utils';
import RaisedButton from 'material-ui/RaisedButton';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';

const styles = {
    panel: {
      backgroundColor: '#fff',
      border: 'none',
      position: 'relative',
      width: '99%',
      fontWeight: typography.fontWeightLight,
    },
    slot:{
      fontSize: 18,
      textAlign:'center'
    },
    box: {
      backgroundColor: '#fff',
      overflow: 'hidden',
      position: 'relative',
      marginBottom: '24px',
      boxShadow: '0 5px 5px 0 rgba(0,0,0,.25)',
    },
    select: {
      width: '30%'
    },
    content: {
      paddingLeft: 10,
      paddingRight: 10
    },
    center: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    add: {
      float: 'right',
      paddingRight: 10,
      cursor: 'pointer'
    },
    noDataText: {
      textAlign: 'center',
      fontSize: 16,
      margin: 20,
      fontWeight: typography.fontWeightLight
    },
    btn: {
      width:'20%',
      marginBottom:'20px',
      marginTop:'10px'
    }
  };
  
  const generateTimeSlot = (conf) => {
    let slots = [];
    let current = moment(conf.startTime);
    while (current <= conf.endTime) {
      let slot = new moment(current);
      slots.push(slot);
      current.add(conf.interval, 'minutes');
    }
    return slots;
  }

const AddSchedule = (props) => {

    let {schedule_start, schedule_end, operatingHours,
         submitSchedule, onChange, doctors, selectedDoctor, onSelectDoctor} = props;
    operatingHours = generateTimeSlot(operatingHours);

    const disableEndTimeOption =(endTimeOption)=>{
    return endTimeOption <= operatingHours[schedule_start];
    }

    const disableStartTimeOption =(startTimeOption)=>{
      return operatingHours[schedule_end] <= startTimeOption;
    }
    
    return (
      <div>
        <SelectField
          floatingLabelText="Doctor"
          value={selectedDoctor}
          onChange={onSelectDoctor}
          style={styles.select}
        >
          
        {
          doctors
          .sort((doctorA, doctorB) => {
            if (doctorA.user.name < doctorB.user.name) {
              return -1;
            }
            else if (doctorA.user.name > doctorB.user.name) {
              return 1;
            }
            else
               return 0;
          })
          .map(d => 
            <MenuItem 
            primaryText={d.user.name}
            key={d.id}
            value={d}/>
          )
          
        }
        </SelectField>
        <br />
        <SelectField
          floatingLabelText="From"
          onChange={onChange.bind(null,'schedule_start')}
          value={schedule_start}
          style={styles.select}
        >
        {
          operatingHours.map((hour, index) => (
            <MenuItem
                key={index}
                value={index}
                primaryText={ utils.toAppTime(hour) }
                disableStartTimeOption={disableStartTimeOption(hour)}
            />
          ))
        }
        </SelectField>
        <br />
        <SelectField
          floatingLabelText="To"
          style={styles.select}
          value={schedule_end}
          onChange={onChange.bind(null,'schedule_end')}
        >
                
        {
          operatingHours.map((hour, index) => (
                <MenuItem
                    disabled={disableEndTimeOption(hour)}
                    key={index}
                    value={index}
                    primaryText={utils.toAppTime(hour)}
                />
            ))
        }
  
        </SelectField>
        <br/>
        <RaisedButton 
           onClick={submitSchedule} 
           label="Add Schedule"
           primary={true}
           style={styles.btn}
           />
        <br />
      </div>
    )
        }
export default AddSchedule;
        





// WEBPACK FOOTER //
// ./src/screens/schedules/add-schedule.js